import React, { useState, useMemo, useEffect, useCallback } from "react";
import Menu from "../../../../components/layout/menu/index";
import '../../../../../src/index.css'
import ListFilter from "../../../../components/filters/listFilters";
import ResetFilters from "../../../../components/filters/resetFilters";
import DownloadDocumentButton from "../../../../components/shared/downloadDocument"
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { getListPurchaseOrder, exportExcelAdmin } from "../../../../client/purchaseOrder";
import FilterInput from "../../../../components/filters/filterInput";


  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };

const statusColors = {
  Aprobado: '#30EA06',
  Nuevo: '#00A3E0',
  Corregido: '#FF6A00',
  'Pendientes de entrega': '#FFB81C',
  Rechazado: '#E44949',
  Vencida: '#FF1C1C',
  Entregado: '#286AD4',
  "Creado": "#77A042"

};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>

export default function OCAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);

  const [resetFlag, setResetFlag] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');

const [downloading, setDownloading] = useState(false);
const [downloadProgress, setDownloadProgress] = useState('');
 
  const [tempFilters, setTempFilters] = useState({
    centerCodes: [],
    groupArticles: [],
    statusIds: [],
    paymentConditions: [],
    withAnticipo: undefined,
    hasMaterial: undefined,
    emissionDateFrom: '',
    emissionDateTo: '',
    releaseDateFrom: '',
    releaseDateTo: '',
    purchasingGroups: [],
    areas: [],
    userCodes: [],
    supplierIds: [],
    applicationCodes:[]
  });
  const [activeFilters, setActiveFilters] = useState({
    centerCodes: [],
    groupArticles: [],
    statusIds: [],
    paymentConditions: [],
    withAnticipo: undefined,
    hasMaterial: undefined,
    emissionDateFrom: '',
    emissionDateTo: '',
    releaseDateFrom: '',
    releaseDateTo: '',
    purchasingGroups: [],
    areas: [],
    userCodes: [],
    supplierIds: [],
    applicationCodes:[],
  });


  const debouncedSearchTerm = useDebounce(searchTerm, 500);


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);


      const response = await getListPurchaseOrder(
      {
        centerCodes: activeFilters.centerCodes,
        groupArticles: activeFilters.groupArticles,
        statusIds: activeFilters.statusIds,
        paymentConditions: activeFilters.paymentConditions,
        withAnticipo: activeFilters.withAnticipo,
        hasMaterial: activeFilters.hasMaterial,
        emissionDateFrom: activeFilters.emissionDateFrom || undefined,
        emissionDateTo: activeFilters.emissionDateTo || undefined,
        releaseDateFrom: activeFilters.releaseDateFrom || undefined,
        releaseDateTo: activeFilters.releaseDateTo || undefined,
        purchasingGroups: activeFilters.purchasingGroups,
        areas: activeFilters.areas,
        userCodes: activeFilters.userCodes,
        supplierIds: activeFilters.supplierIds,
        applicationCodes: activeFilters.applicationCodes,
      }, 
      searchTerm.trim() !== '' ? searchTerm : undefined, 
      currentPage, 
      recordsPerPage
    );
      setAllData(response.data.data);
      setTotalRecords(response.data.totalCount);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message || "Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  }, [activeFilters, currentPage, recordsPerPage, searchTerm]); 

  useEffect(() => {
    const handleOCsUpdated = () => {
      fetchData();
    };

    window.addEventListener('ocs-updated', handleOCsUpdated);
    
    return () => {
      window.removeEventListener('ocs-updated', handleOCsUpdated);
    };
  }, [fetchData]);
  
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const tableConfig = {
    headers: [
      "#",
      "Número OC",
      "Denominación de OC",
      "Estado",
      "Fecha de emisión",
      "Fecha de entrega",
      "Grupo de compras",
      "Posición",
      "Tipo de posición",
      "Descripción Cl.DC",
      "Acreedor",
      "Descripción del Proveedor",
      "Descripción del Centro",
      "Anticipo",
      "Tipo de imputación",
      "Tipo posición",
      "Texto tipo pos.",
      "Cat. Valoración",
      "Descripción CatVa",
      "Tipo material",
      "Material",
      "Descripción pos",
      "Cantidad de pedido",
      "UM de pedido",
      "Pr. Neto",
      "Moneda",
      "Monto Neto",
      "Tipo de cambio",
      "Grupo artículos",
      "Denom.gr-artíc.",
      "Comp.resp.2",
      "Denom.comp.resp.2",
      "Centro",
      "Almacén",
      "Creador Gasto",
      "Condición de Pago",
      "Forma de pago",
      "Entrega final",
      "Cantidad EM",
      "Sol.pedido",
      "Pos.sol.pedido",
      "Fecha solicitud",
      "Fecha entrega",
      "Nom Solic SolPed",
      "Usr.creador",
      "Mon.solped",
      "Prc.solped",
      "Prc.solped USD",
      "Valor $ PostVenta",
      "Dscto/Recargo $ OC",
      "Número de proforma",
      "Motivo de rechazo",
      "Est.aprob.Prov.",
      "Estado aprob. Prov.",
      "Retenido",
      "Monto bruto",
      "Monto bruto $",
      "Grupo liberac.",
      "Estrat.liberac.",
      "Denominación",
      "Ind.liberación",
      "Solicitante",
      "Incoterms",
      "Valor dolarizado",
      "Fecha contab.",
      "Año EM",
      "Mes EM",
      "Grupo liberac.",
      "Denominación",
      "Cod. liberación",
      "Status",
      "Clase documento",
      "Denom.Lib.OC 1",
      "Denom.Lib.OC 2",
      "Denom.Lib.OC 3",
      "Denom.Lib.OC 4",
      "Denom.Lib.OC 5",
      "Denom.Lib.OC 6",
      "Denom.Lib.OC 7",
      "Denom.Lib.OC 8",
      "Fecha liberacion 1",
      "Fecha liberación 2",
      "Fecha liberación 3",
      "Fecha de liberación 4",
      "Fecha de liberación 5",
      "Fecha de liberación 6",
      "Fecha de liberación 7",
      "Fecha de liberación 8",
      "Ultima Fe. Lib",
      "Descripción",
      "Ind.borrado",
      "Ind.liber.",
      "Observación pedido",
      "Texto pos.OC",
      "Categoría de pedido",
      "Status tratamiento d",
     // "EM Fecha",
      "EM Cant.",
      "EM $",
      "FACT $"
    ],
    accessors: [
      "displayId",
      "order_number", //Número de OC
      "denomination", //Denominación de OC
      "status", //Estado
      "emission_date", //Fecha de emisión
      "delivery_Date", //Fecha de entrega
      "purchase_group", //Grupo de compras
      "position_number", // Posicion 
      "position_type", //Tipo de posición
      "description_cidc", //Descripción C1.DC
      "supplier_code", //Accreedor
      "supplier_name", //Descripcion del proveedor
      "center_code", // Descripcion del centro
      "anticipo", // Anticipo 
      "imputation_type", //Tipo de imputación
      "position_type", // Tipo posición
      "text_position_type", // Texto tipo posicion 
      "valoration_category", // Cat. Valoración
      "valoration_category_description", // Descripción CatVa
      "material_type", // Tipo Material
      "material", // Material
      "description", //Descripcion Pos
      "cant", //Cantidad de Pedido 
      "unit_weight", //UM de pedido
      "price_per_unit", // Pr. Neto
      "coin", //Moneda
      "net_amount", //Monto Neto
      "exchange_rate", //Tipo de cambio
      "group_article", //Grupo de artículos
      "denom_article", // Denom.gr-artic
      "comp_res_2", //Comp.resp.2
      "denomination_2", //Denom.comp.resp.2
      "center_code_2", //Centro 
      "store", //Almacen
      "user_code", //Creador gasto
      "payment_condition", //Condicion de pago
      "method_payment", // Forma de pago
      "final_delivery",  //Entrega final
      "unit_measure_delivery", // Cantidad EM
      "solped_number", // Sol. Pedido
      "solped_position", // Pos.sol.pedido
      "solped_date", // Fecha de solicitud
      "delivery_Date", //Fecha entrega 
      "nom_solped", //Nom solic Sol Ped
      "applicant_code", //Usr.creador
      "solped_coin", //Mon.solped
      "price_solped", // Prc.solped
      "price_solped_dollarized", //Prc.solped USD
      "solped_after_sale", //Valor $ PostVenta
      "solped_desc", // Dscto/REcargo $ OC
      "proforma", //Numero de proforma
      "rejection_reason", //Motivo de rechazo
      "status_ap_supplier", //Est.aprob.Prov.
      "status_approve_supplier", // Estado aprob. Prov.
      "detained", //Retenido
      "gross_amount", //Monto bruto
      "gross_amount_dollarized", // MonstoBruto$
      "liberation_group", // Grupo liberac
      "strat_liberation", //Estrat. Liberac
      "denomination_liberation", // Denominacion
      "liberation_index", //Ind.Liberacion
      "solicitate", //Solicitante
      "incoterms", //Incoterms
      "dollarized_deliver", //VAlor dolarizado
      "contab_date", //Fecha contab.
      "year_em", //Año EM
      "month_em", //Mes EM
      "liberation_group_2", //Grupo liberac. 2
      "denomination_liberation_2", //DenominacionLib 2
      "liberation_code", //Cod liberación
      "status_position", //Estado liberacion
      "document_type", //Clase documento
      "denom_lib_oc1", //Denom.Lib.Oc 1
      "denom_lib_oc2", // Denom.Lib.Oc 2
      "denom_lib_oc3", //Denom.Lib.Oc 3
      "denom_lib_oc4", // Denom.Lib.Oc 4
      "denom_lib_oc5", //Denom Lib.Oc 5
      "denom_lib_oc6", // Denom Lib.Oc 6
      "denom_lib_oc7", //Denom.Lib.Oc 7
      "denom_lib_oc8", //Denom.Lib.Oc 8
      "liberation_date_1", //Fecha liberacion 1
      "liberation_date_2", //Fecha lib 2
      "liberation_date_3",//Fecha lib 3
      "liberation_date_4",//Fecha lib 4
      "liberation_date_5",//Fecha lib 5
      "liberation_date_6",//Fecha lib 6
      "liberation_date_7",//Fecha lib 7
      "liberation_date_8",//Fecha lib 8
      "last_release_Date", //Ultima fecha de lib
      "liberation_description", //Descripcion
      "index_erase", //Ind. borrado
      "liberation_index", //Ind.liber
      "order_observation", //Observacion pedido
      "oc_position_text", //TExto pos.OC
      "order_category", //categoria de pedido
      "procstat", // STatus tratamiendo d
     // "em_date", //Em Fecha
      "em_cant", //EM cant
      "em_dollarized", // Em$
      "fact_dollarized" //FACT $
    ],
    widths: [
      "75px",    // #
      "121px",   // Número OC
      "260px",   // Denominación de OC
      "120px",   // Estado
      "112px",   // Fecha de emisión
      "112px",   // Fecha de entrega
      "112px",   // Grupo de compras
      "112px",    // Posición
      "112px",   // Tipo de posición
      "137px",   // Descripción Cl.DC
      "137px",   // Acreedor
      "185px",   // Descripción del Proveedor
      "185px",   // Descripción del Centro
      "185px",    // Anticipo
      "127px",   // Tipo de imputación
      "127px",   // Tipo posición
      "127px",   // Texto tipo pos.
      "127px",   // Cat. Valoración
      "127px",   // Descripción CatVa
      "127px",   // Tipo material
      "127px",   // Material
      "253px",   // Descripción pos
      "127px",   // Cantidad de pedido
      "127px",    // UM de pedido
      "127px",   // Pr. Neto
      "127px",    // Moneda
      "127px",   // Monto Neto
      "127px",   // Tipo de cambio
      "105px",   // Grupo artículos
      "169px",   // Denom.gr-artíc.
      "169px",   // Comp.resp.2
      "200px",   // Denom.comp.resp.2
      "127px",   // Centro
      "127px",   // Almacén
      "169px",   // Creador Gasto
      "127px",   // Condición de Pago
      "169px",   // Forma de pago
      "127px",   // Entrega final
      "127px",   // Cantidad EM
      "181px",   // Sol.pedido
      "181px",   // Pos.sol.pedido
      "127px",   // Fecha solicitud
      "127px",   // Fecha entrega
      "181px",   // Nom Solic SolPed
      "181px",   // Usr.creador
      "127px",    // Mon.solped
      "144px",   // Prc.solped
      "144px",   // Prc.solped USD
      "127px",   // Valor $ PostVenta
      "160px",   // Dscto/Recargo $ OC
      "144px",   // Número de proforma
      "144px",   // Motivo de rechazo
      "144px",   // Est.aprob.Prov.
      "144px",   // Estado aprob. Prov.
      "144px",    // Retenido
      "144px",   // Monto bruto
      "144px",   // Monto bruto $
      "144px",   // Grupo liberac.
      "144px",   // Denominación
      "144px",   // Ind.liberación
      "144px",   // Solicitante
      "144px",   // Incoterms
      "144px",   // Valor dolarizado
      "144px",   // Fecha contab.
      "144px",    // Año EM
      "144px",    // Mes EM
      "144px",   // Grupo liberac.
      "144px",   // Estrat.liberac.
      "144px",   // Denominación
      "144px",   // Cod. liberación
      "144px",   // Status
      "144px",   // Clase documento
      "144px",   // Denom.Lib.OC 1
      "144px",   // Denom.Lib.OC 2
      "144px",   // Denom.Lib.OC 3
      "144px",   // Denom.Lib.OC 4
      "144px",   // Denom.Lib.OC 5
      "144px",   // Denom.Lib.OC 6
      "144px",   // Denom.Lib.OC 7
      "144px",   // Denom.Lib.OC 8
      "144px",   // Fecha liberacion 1
      "144px",   // Fecha liberación 2
      "144px",   // Fecha liberación 3
      "144px",   // Fecha de liberación 4
      "144px",   // Fecha de liberación 5
      "144px",   // Fecha de liberación 6
      "144px",   // Fecha de liberación 7
      "144px",   // Fecha de liberación 8
      "144px",   // Ultima Fe. Lib
      "144px",   // Descripción
      "144px",   // Ind.borrado
      "144px",   // Ind.liber.
      "144px",   // Observación pedido
      "527px",   // Texto pos.OC
      "177px",   // Categoría de pedido
      "177px",   // Status tratamiento d
     // "145px",   // EM Fecha
      "145px",   // EM Cant.
      "145px",   // EM $
      "145px"    // FACT $
    ]
  };

  const transformedData = useMemo(() => {
    return allData.map((item, index) => {

    const formatDecimal = (value) => {
      if (value === null || value === undefined) return '';
      const num = parseFloat(value);
      if (isNaN(num)) return '';
      
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };
    
    return {
      ...item,
      displayId: (currentPage - 1) * recordsPerPage + index + 1,
      status: item.status?.status?.name || 'Nuevo',
      position_number: item.position?.number || '',
      purchase_group: item.purchaseGroup?.group || '',
      area_name: item.purchaseGroup?.area?.name || '',
      material: item.material || '',
      description: item.description || '',
      center_code: item.center_code || '',
      cant: item.cant || 0,
      coin: item.coin || '',
      delivery_Date: item.delivery_Date || '',
      emission_date: item.purchaseOrder?.emission_date || '',
      anticipo: item.anticipo || '',
      group_article: item.group_article || '',
      order_number: item.purchaseOrder?.order_number || '',
      supplier_name: item.purchaseOrder?.supplier?.name || '',
      final_delivery: item.final_delivery ? "Sí" : "No" || '',
      supplier_code: item.purchaseOrder?.supplier?.code || '',
      exchange_rate: item.exchange_rate || '',
      price_per_unit: formatDecimal(item.price_per_unit),
      solped_desc: formatDecimal(item.solped_desc),
      solped_after_sale: formatDecimal(item.solped_after_sale),
      price_solped_dollarized: formatDecimal(item.price_solped_dollarized),
      price_solped: formatDecimal(item.price_solped),
      net_dollarized_amount: formatDecimal(item.net_dollarized_amount),
      net_amount: formatDecimal(item.net_amount),
      gross_amount_dollarized: formatDecimal(item.gross_amount_dollarized),
      gross_amount: formatDecimal(item.gross_amount),
      fact_dollarized: formatDecimal(item.fact_dollarized),
      em_dollarized: formatDecimal(item.em_dollarized),
      dollarized_deliver_finish: formatDecimal(item.dollarized_deliver_finish),
      dollarized_deliver: formatDecimal(item.dollarized_deliver),
      applicant_code: item.purchaseOrder?.applicant_code,
      nom_solped: item.purchaseOrder?.nom_solped,
      solped_date: item.purchaseOrder?.solped_date,
      user_code: item.purchaseOrder?.user_code,
      comp_res_2: item.comp_res_2,
      status_position: item.status_position,
      last_release_Date: item.last_release_Date,
      liberation_code: item.liberation_code

    };
  });
}, [allData]);

  const currentPageData = useMemo(() => {
    return transformedData; 
  }, [transformedData]);

  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const [filterOptions, setFilterOptions] = useState([
    { 
      title: "Tipo de compra:", 
      options: ["Material", "Servicio", "Todos"] 
    },
    { 
      title: "Estado de OC:", 
    },
    { 
      title: "Año de Liberación:", 
    },
    { 
      title: "Año de creación:", 
    },
    { 
      title: "Comprador:", 
    },
    { 
      title: "Grupo de Compras:", 
    },
    { 
      title: "Con Anticipo:", 
      options: ["Sí", "No", "Todos"] 
    },
    { 
      title: "Cond de Pago:", 
    },
    { 
      title: "Centro:", 
    },
    { 
      title: "Proveedor:", 
    },

    { 
      title: "Cod Solicitante:", 
    },
    /*
    { 
      title: "Solicitante:", 
    },
*/
    { 
      title: "Grupo Artículos:", 
    },

  ]);

  const handleFilterChange = (filterTitle, value) => {
    if (filterTitle === "Tipo de compra:") {
      let hasMaterialValue;
      if (value === "Material") hasMaterialValue = true;
      else if (value === "Servicio") hasMaterialValue = false;
      else hasMaterialValue = undefined;
      
      setTempFilters(prev => ({
        ...prev,
        hasMaterial: hasMaterialValue
      }));
    } 
    
    else if (filterTitle === "Estado de OC:") {
      setTempFilters(prev => ({
        ...prev,
        statusIds: value || [] 
      }));
    }

    else if (filterTitle === "Con Anticipo:") {
      let withAnticipoValue;
      if (value === "Sí") withAnticipoValue = true;
      else if (value === "No") withAnticipoValue = false;
      else withAnticipoValue = undefined;
      
      setTempFilters(prev => ({
        ...prev,
        withAnticipo: withAnticipoValue
      }));
    }

    else if (filterTitle === "Grupo de Compras:") {
      setTempFilters(prev => ({
        ...prev,
        purchasingGroups: value
      }));
    }

    else if (filterTitle === "Comprador:") {
      setTempFilters(prev => ({
        ...prev,
        userCodes: value
      }));
    }

    else if (filterTitle === "Cod Solicitante:") {
      setTempFilters(prev => ({
        ...prev,
        applicationCodes: value
      }));
    }

    else if (filterTitle === "Cond de Pago:") {
      setTempFilters(prev => ({
        ...prev,
        paymentConditions: value
      }));
    }

    else if (filterTitle === "Proveedor:") {
      setTempFilters(prev => ({
        ...prev,
        supplierIds: value
      }));
    }

    else if (filterTitle === "Grupo Artículos:") {
      setTempFilters(prev => ({
        ...prev,
        groupArticles: value
      }));
    }
  };

  const handleCenterCodesChange = (selectedCenterCodes) => {
    setTempFilters(prev => ({
      ...prev,
      centerCodes: selectedCenterCodes
    }));
  };

  const handleDateRangeChange = ({ emissionDateFrom, emissionDateTo, releaseDateFrom, releaseDateTo }) => {
    setTempFilters(prev => ({
      ...prev,
      emissionDateFrom: emissionDateFrom || prev.emissionDateFrom,
      emissionDateTo: emissionDateTo || prev.emissionDateTo,
      releaseDateFrom: releaseDateFrom || prev.releaseDateFrom,
      releaseDateTo: releaseDateTo || prev.releaseDateTo
    }));
  };

  const handleCategoryChange = (selectedAreaIds) => {
    setTempFilters(prev => ({
      ...prev,
      areas: selectedAreaIds
    }));
  };

  const applyFilters = () => {
    setActiveFilters({ ...tempFilters });
    setCurrentPage(1); 
  };

  const handleResetFilters = () => {

    const resetFilters = {
      centerCodes: [],
      groupArticles: [],
      statusIds: [],
      paymentConditions: [],
      withAnticipo: undefined,
      hasMaterial: undefined,
      emissionDateFrom: '',
      emissionDateTo: '',
      releaseDateFrom: '',
      releaseDateTo: '',
      purchasingGroups: [],
      areas: [],
      userCodes: [],
      supplierIds: [],
      applicationCodes: []
    };
    
    setTempFilters(resetFilters);
    setActiveFilters(resetFilters);
    setSearchTerm('');
    setCurrentPage(1);
    setResetFlag(prev => !prev);
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloading(true);

      setDownloadProgress('Preparando descarga...');
    
      await new Promise(resolve => setTimeout(resolve, 500));
    
      setDownloadProgress('Generando archivo Excel... (Esto puede tomar unos segundos)');
      
      const response = await exportExcelAdmin({
        centerCodes: activeFilters.centerCodes,
        groupArticles: activeFilters.groupArticles,
        statusIds: activeFilters.statusIds,
        paymentConditions: activeFilters.paymentConditions,
        withAnticipo: activeFilters.withAnticipo,
        purchasingGroups: activeFilters.purchasingGroups,
        areas: activeFilters.areas,
        userCodes: activeFilters.userCodes,
        emissionDateFrom: activeFilters.emissionDateFrom,
        emissionDateTo: activeFilters.emissionDateTo,
        hasMaterial: activeFilters.hasMaterial,
        releaseDateFrom: activeFilters.releaseDateFrom,
        releaseDateTo: activeFilters.releaseDateTo,
        supplierIds: activeFilters.supplierIds,
        applicationCodes: activeFilters.applicationCodes,
        search: searchTerm.trim() !== '' ? searchTerm : undefined  
      });

      setDownloadProgress('Finalizando descarga...');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'OrdenesDeCompra.xlsx';
      
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

    setDownloadProgress('');

      
    } catch (error) {
    console.error('Error al descargar el Excel:', error);
    setDownloadProgress('Error al descargar. Por favor, intente nuevamente.');
    
    setTimeout(() => {
      setDownloadProgress('');
    }, 3000);
    } finally {
      setDownloading(false);
    }
  };

  const handleRecordsCountChange = (e) => {
    const newRecordsPerPage = parseInt(e.target.value);
    setRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); 
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
      {/* Overlay de carga para descarga */}
      {downloading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
          <div className="max-w-md p-6 mx-4 bg-white rounded-lg">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 border-b-2 rounded-full animate-spin border-blue"></div>
            </div>
            <p className="mb-2 text-center text-gray-700 font-itcmedium">
              Descargando archivo...
            </p>
            <p className="text-sm text-center text-gray-600 font-itcbook">
              {downloadProgress}
            </p>
            <p className="mt-3 text-xs text-center text-gray-500 font-itcbook">
              Por favor espere, este proceso puede tomar varios segundos.
            </p>
          </div>
        </div>
      )}
        
        <div className="md:pt-8 pt-4 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-4">
            <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
              <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">Órdenes de Compra</h1>
              <div className="flex flex-col items-center gap-6 md:flex-row">
                <div className="flex items-center">
                  <DownloadDocumentButton
                    text="Descargar"
                    onClick={handleDownloadExcel}
                    loading={downloading}
                    hasData={allData.length > 0}
                  />
                </div>
                <div className="flex flex-row items-center gap-6 ">
                    <ListFilter
                      titleOption="Filtros"
                      font="font-itcmedium"
                      classname="w-[110px]"
                      filters={filterOptions}
                      showCategoryFilterOCAdmin={true}
                      onCategoryChange={handleCategoryChange}
                      onCenterCodesChange={handleCenterCodesChange}
                      onFilterChange={handleFilterChange}
                      onDateRangeChange={handleDateRangeChange}
                      applyFilters={applyFilters}
                      resetStatusFilter={false}
                      resetFlag={resetFlag}
                      activeFilters={activeFilters}
                    />
                    <ResetFilters
                      borderColor="border-blue-light"
                      textColor="text-[#6B7280]"
                      font="font-itcbook"
                      onClick={handleResetFilters}
                    />
                </div>
              </div>
            </div>
            <div className="flex flex-col-reverse items-start justify-between gap-2 sm:items-center sm:flex-row">
              <div className="flex items-center space-x-2 text-sm font-itcbook">
                <p >Mostrar</p>
                <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                  <select
                    className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                    value={recordsPerPage}
                    onChange={handleRecordsCountChange}  
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <p >Registros</p>
              </div>
              <FilterInput
                placeholder="Buscar OC"
                value={searchTerm}
                onChange={(e) => {
                  const inputValue = e.target.value;
                    if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                      setSearchTerm(inputValue);
                      setCurrentPage(1); 
                    }
                  }}
                classname="sm:w-auto md:w-full"
              />
            </div>
            <DynamicTable
              data={currentPageData}
              config={tableConfig}
              statusColors={statusColors}
              currentPage={currentPage}
              totalPages={totalPages}
              recordsPerPage={recordsPerPage}
              totalRecords={totalRecords}
              changePage={handlePageChange}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}